<div class="banner-birthday">
  <!-- <div class="banner-birthday-content-logo">
    <img
      src="https://ik.imagekit.io/puzzl/mediaitems/public/20250508_232341_r25.mi"
      alt="bolo-unhide"
    />
    <p>
      Aniversário da
      <span class="emphasis">UNHIDE</span>. Corre que tem presente pra você!
    </p>
     </div> -->
  <p style="width: 100%; margin: 0 10px; text-align: center">
    Última semana de Black Friday. Aproveite o melhor desconto do ano! 
    <!-- <span class="emphasis">50%</span> -->
    <a href="https://unhideschool.com/assinatura/planos-e-precos">
      Garanta agora!</a
    >!
  </p>
  <p style="width: 100%; margin: 0 10px; text-align: center">
    Essa oferta acaba em {{ this.countdown }}
  </p>
</div>
